import { createFileRoute } from '@tanstack/react-router'

import { productsQuery } from '../lib/queries'
import { Reaction } from '../screens/Reaction'

export const Route = createFileRoute('/reaction')({
  validateSearch: (search: Record<string, unknown>): { step: number } => ({
    step: Number.isFinite(Number(search.step)) ? Math.min(4, Math.max(0, Number(search.step))) : 0,
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(productsQuery({ status: 'active' })),
  component: Reaction,
})
